import React from "react";

export function JobTracker() {
	return <div>Job Tracker page</div>;
}
